import { CommonFlags as c, DefaultColumns, EntityColumn, EntityColumnFlags, EntityDefinition } from "@mcurros2/microm";

const columns = () =>
(
    {
        c_user_id: new EntityColumn<string>({ name: 'c_user_id', type: 'char', length: 20, flags: c.PK, prompt: 'Cliente' }),
        vc_username: new EntityColumn<string>({ name: 'vc_username', type: 'varchar', length: 255, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Username' }),
        vc_password: new EntityColumn<string>({ name: 'vc_password', type: 'varchar', length: 2048, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Password' }),
        ...DefaultColumns()
    }
)

const views = () =>
(
    {
        uspw_brwPersonal: { name: 'uspw_brwPersonal', keyMappings: { c_user_id: 0 } },
        uspw_brwClientes: { name: 'uspw_brwClientes', keyMappings: { c_user_id: 0 } },
    }
)

export class UsuariosPasswordDef extends EntityDefinition {

    columns = columns();
    views = views();

    constructor() {
        super('UsuariosPassword');
    }
}